import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import ListeaDocentes from "./ListeaDocentes";
import socket from "../tools/socke";

const DocenteBuscadorGlobal = ({ devuelvo, criterio }) => {

  const [visible, setVisible] = useState(false);
  const [docentesFiltrados, setDocentesFiltrados] = useState([]);
  const [filtro, setFiltro] = useState("");
  const inputRef = useRef(null); // Referencia para el input
  const[datoPlace,setDatoPlace]=useState("Buscar por apellido o DNI")
  // Enfocar el input al montar el componente
  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  // Escuchar el evento del WebSocket
  useEffect(() => {
    socket.on("docenteActualizable", () => {
      if (filtro) {
        obtieneDocente(filtro);
      }
    });

    return () => {
      socket.off("docenteActualizable");
    };
  }, [filtro]);

  // Función para obtener los cadetes filtrados desde el backend
  const obtieneDocente = async (dato) => {
    try {
      if (dato.length > 1) {
        const username = process.env.REACT_APP_KEY;
        const password = process.env.REACT_APP_PASS;
        const token = btoa(`${username}:${password}`);

        const response = await axios.post(
          `https://wwwa.isepsantafe.net.ar/expedientes/docentes/devuelveDocentesCualquierCondicion/${dato}`,[],
         
          {
            headers: {
              Authorization: `Basic ${token}`,
            },
          }
        );


        setVisible(true);
        setDocentesFiltrados(response.data.datos || []);
      } else {
        setDocentesFiltrados([]);
      }
    } catch (error) {
      console.error("Error en la petición", error);
    }
  };

  // Manejar cambios en el filtro
  const handleInputChange = (e) => {
    const texto = e.target.value;
    setFiltro(texto);
    obtieneDocente(texto);
  };

  // Emitir evento con el WebSocket
  const enciendeLectores = (va) => {
    devuelvo(va);
    setDocentesFiltrados([])
  };

  return (
    <div >
      <div style={{width:"300px", justifyContent:"center",display:"flex", padding:"5px"}}>
      
        <input
          ref={inputRef} // Asignar la referencia al input
          type="text"
          placeholder={datoPlace}
          value={filtro}
          onChange={handleInputChange}
          style={{
            padding: "10px",
            fontSize: "16px",
           
            width: "80%",
            boxSizing: "border-box",
            textAlign: "center",
            height:"40px"
          }}
        />
      </div>
      {visible && docentesFiltrados.length > 0 && (<>
        <div style={{maxHeight:"300px",display:"flex", overflowY: "auto",position:"absolute"}}>
        <ListeaDocentes
          actualiza={(value) => enciendeLectores(value)}
          items={docentesFiltrados}
        /></div>
      </>)}
      {visible && docentesFiltrados.length === 0 && (<>
        {()=>setDatoPlace("No hay docentes con esos datos")}
      </>)}
    </div>
  );
};

export default DocenteBuscadorGlobal;
